module.exports = new __parcel__URL__("bronze_pack_icon.31234a60.png").toString();